<div *ngIf="isBusy()" class="xmodal">
    <div class="spinner">
        <div class="spinner-border text-secondary" role="status">
            <span class="sr-only">{{ 'Busy' | translate }}</span>
        </div>
    </div>
    <ng-container
        *ngIf="core.getWaitingForList(); let waitingForList"
        class="waitingForList"
        (click)="openMethodList()">
        <div *ngIf="waitingForList.length>0" class="waitingFor">
            <div *ngFor="let waitingFor of waitingForList"
                 (click)="openMethodList()">{{ waitingFor.name }}
            </div>
        </div>
    </ng-container>
</div>
